import { render, staticRenderFns } from "./Bhold.vue?vue&type=template&id=7f554df4&"
import script from "./Bhold.vue?vue&type=script&lang=js&"
export * from "./Bhold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports